<template>
  <div id="spye-series">
    <NavigationBar />

    <!-- <div class="uk-section" id="section-one">
      <div class="uk-container">
        <div class="uk-child-width-1-1" id="banner">
          <h1 class="uk-text-center uk-text-uppercase" id="banner-title">
            THE SPYE SERIES
          </h1>
          <div class="uk-height-large"></div>
        </div>
      </div>
    </div> -->

    <!-- <div class="uk-section">
      <div class="uk-container">
        <div
          class="uk-flex uk-flex-middle"
          id="price-tag"
          uk-grid
          uk-height-match="target: > div > .price-tag-item; row: false"
          uk-scrollspy="cls: uk-animation-fade; target: .price-tag-item; delay: 500; repeat: false;"
        >
          <div
            class="uk-width-1-3@s"
            uk-scrollspy-class="uk-animation-slide-bottom"
            v-for="product in products"
            :key="product.id"
          >
            <div class="price-tag-item">
              <h3 class="price-tag-item-title">{{ product.title }}</h3>
              <p class="price-tag-item-description">
                {{ product.description }}
              </p>

              <ul class="uk-padding-remove-left price-tag-item-list">
                <li v-for="list in product.descList" :key="list">{{ list }}</li>
              </ul>

              <router-link :to="product.link">Learn more</router-link>

              <div
                class="uk-cover-container uk-background-muted price-tag-image-container"
              >
                <img :src="product.img" :alt="product.title" uk-img />
              </div>
            </div>
            <div width="100%">
              <router-link
                :to="product.link"
                class="uk-button uk-button-primary price-tag-button"
                >BUY NOW</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- desktop -->
    <div v-if="!isVerySmall">
      <div class="uk-section">
        <div class="uk-container">
          <div class="uk-width-1-1 uk-flex uk-flex-center">
            <h1 class="text-color-primary">Compare ROOMI Cams</h1>
          </div>
        </div>
      </div>
      <div class="uk-section uk-padding-remove-top" v-if="!loading">
        <div class="uk-container">
          <div class="uk-overflow-auto">
            <table class="uk-table uk-table-divider">
              <tbody>
                <tr
                  v-for="(item, index) in data"
                  :key="index"
                  :style="
                    item.name == 'Type' ? 'border-top: none !important;' : ''
                  "
                >
                  <th
                    :style="`${
                      item.name == 'Type'
                        ? 'vertical-align: top;'
                        : 'vertical-align: middle;'
                    }`"
                  >
                    {{ item.name != "image" ? item.name : "" }}
                  </th>
                  <td
                    v-for="(child, i) in item.childs"
                    :key="i"
                    class="uk-text-center"
                  >
                    <div
                      v-if="item.name == 'image'"
                      style="width: 250px; display: inline-block"
                      class="uk-cover-container"
                    >
                      <img :src="child" uk-img style="object-fit: cover" />
                    </div>
                    <div
                      v-else-if="item.name == 'Type'"
                      class="
                        compare-type-section
                        uk-flex uk-flex-center uk-padding-large uk-flex-middle
                      "
                    >
                      <div>
                        <div class="uk-width-1-1 uk-text-center">
                          {{ child.name }}
                        </div>
                        <router-link
                          class="uk-button uk-button-default uk-button-small"
                          style="
                            margin-top: 10px;
                            color: white;
                            border-radius: 5px;
                          "
                          :to="`/product/${child.seo_url}`"
                        >
                          Buy Now
                        </router-link>
                      </div>
                    </div>
                    <div v-else>
                      <div style="padding: 30px 0; background: #fafafa">
                        {{ child }}
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="uk-section uk-padding-remove-top" v-else>
        <div class="uk-container">
          <div
            class="uk-flex uk-flex-center uk-flex-middle"
            style="height: 100%"
          >
            <div uk-spinner></div>
          </div>
        </div>
      </div>
    </div>

    <!-- mobile -->
    <div v-else>
      <div class="uk-section uk-padding-remove-bottom">
        <div class="uk-container">
          <div class="uk-width-1-1 uk-flex uk-flex-center">
            <h2 class="text-color-primary" style="text-align: center">
              Compare ROOMI Cams
            </h2>
          </div>
        </div>
      </div>
      <div class="uk-section uk-padding-remove-top" v-if="!loading">
        <div class="uk-container">
          <div>
            <div v-for="(item, i) in data" :key="i">
              <div
                v-if="item.name == 'Type'"
                style="z-index: 980; background: white"
                uk-sticky="bottom: #offset"
              >
                <div
                  :class="`uk-flex uk-flex-center ${
                    item.name == 'image' || item.name == 'Type'
                      ? ''
                      : 'uk-padding-small'
                  }`"
                  :style="`${
                    item.name == 'image' || item.name == 'Type'
                      ? ''
                      : 'background: #F1F1F1;'
                  } font-weight: bold;`"
                >
                  {{
                    item.name == "image" || item.name == "Type" ? "" : item.name
                  }}
                </div>
                <div class="uk-flex uk-flex-center uk-padding-small" uk-grid>
                  <div
                    class="uk-width-1-3 uk-flex uk-flex-center"
                    v-for="(child, j) in item.childs"
                    :key="j"
                  >
                    <div v-if="item.name == 'image'">
                      <img :src="child" />
                    </div>
                    <div v-else-if="item.name == 'Type'">
                      <div
                        class="uk-width-1-1 uk-flex uk-flex-center line-clamp"
                        style="font-weight: bold; overflow: hidden"
                      >
                        {{ child.name }}
                      </div>
                      <div class="uk-width-1-1" style="margin-top: 10px">
                        <router-link
                          class="
                            uk-button
                            uk-button-primary
                            uk-button-small
                            uk-width-1-1
                          "
                          :to="`/product/${child.seo_url}`"
                        >
                          Buy Now
                        </router-link>
                      </div>
                    </div>
                    <div v-else>{{ dataCompare }}</div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div
                  :class="`uk-flex uk-flex-center ${
                    item.name == 'image' || item.name == 'Type'
                      ? ''
                      : 'uk-padding-small'
                  }`"
                  :style="`${
                    item.name == 'image' || item.name == 'Type'
                      ? ''
                      : 'background: #FAFAFA;'
                  } font-weight: bold;`"
                >
                  {{
                    item.name == "image" || item.name == "Type" ? "" : item.name
                  }}
                </div>
                <div class="uk-flex uk-flex-center uk-padding-small" uk-grid>
                  <div
                    class="uk-width-1-3 uk-flex uk-flex-center"
                    v-for="(child, j) in item.childs"
                    :key="j"
                  >
                    <div v-if="item.name == 'image'">
                      <img :src="child" />
                    </div>
                    <div v-else>{{ child }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="uk-section uk-padding-remove-top" v-else>
        <div class="uk-container">
          <div
            class="uk-flex uk-flex-center uk-flex-middle"
            style="height: 100%"
          >
            <div uk-spinner></div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import NavigationBar from "@/components/NavigationBar.vue";
import Footer from "@/components/Footer.vue";
import $axios from "@/api.js";
import { mapActions, mapGetters } from "vuex";
import UIkit from "uikit";
import axios from "axios";

export default {
  name: "spyeSeries",
  assetsSubDirectory: "./assets",
  components: {
    NavigationBar,
    Footer,
  },
  data() {
    return {
      data: [],
      loading: true,
    };
  },
  computed: {
    ...mapGetters("auth", ["IS_AUTH", "GET_USER"]),
    isVerySmall() {
      return window.innerWidth < 640;
    },
  },
  mounted() {
    //   console.log(this.listCompare)
    this.getData();
  },
  methods: {
    ...mapActions("cart", ["getCarts"]),
    getData() {
      this.loading = false;
      this.data = [];
      axios
        .get(
          `${process.env.VUE_APP_API_ROOMI_URL}compare-product?category_id=3`
        )
        .then((res) => {
          this.loading = false;
          if (res.status == 200) {
            const temp = [];
            temp.push({ name: "image", childs: [] });
            temp.push({ name: "Type", childs: [] });
            for (const item of res.data.data) {
              for (const spec of item.specifications) {
                temp.push({ name: spec.name, childs: [] });
              }
            }
            const grouping = [...new Set(temp.map((item) => item.name))];
            const tempGrouping = [];
            for (const item of grouping) {
              const data = { name: item, childs: [] };
              for (const prod of res.data.data) {
                if (item == "Type") {
                  data.childs.push({
                    name: prod.name,
                    seo_url: prod.seo_url,
                  });
                } else if (item == "image") {
                  data.childs.push(prod.thumbnail);
                } else {
                  for (const spec of prod.specifications) {
                    if (item == spec.name) {
                      data.childs.push(spec.value);
                    }
                  }
                }
              }
              tempGrouping.push(data);
            }
            this.data = tempGrouping;
          } else {
            UIkit.notification({
              status: "danger",
              message: "Something went wrong",
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          UIkit.notification({
            status: "danger",
            message: "Something went wrong",
          });
        });
    },
  },
};
</script>


<style scoped lang="less">
@import "../custom/custom.less";
#section-one {
  background-color: rgb(240, 240, 241);
}

#banner .uk-height-large {
  background-image: url("../assets/SPEED 6S-2.png");
  background-size: 90%;
  background-repeat: no-repeat;
  background-position: center;
}

.line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

#banner-title {
  width: 100%;
  color: rgb(148, 149, 153);
  margin-bottom: 0;
  margin-top: 0;
  font-weight: 100;
  font-size: 74px;
  letter-spacing: 3.5px;
  transform: scaleX(1.2);
  transform-origin: center;
}

#price-tag {
  margin-bottom: 18%;
}

.price-tag-item {
  border: 1px solid rgb(89, 88, 90);
  border-radius: 15px;
  display: grid;
}

.price-tag-item-title {
  font-size: 20px;
  margin: 20px 30px;
  letter-spacing: 0.3vw;
  color: rgb(95, 103, 105);
  line-height: normal;
}

.price-tag-item-description {
  color: rgb(194, 195, 197);
  margin: 0 30px 20px 30px;
  letter-spacing: 2px;
  font-weight: 100;
  min-height: 4vw;
  line-height: 1;
  font-size: 1.2vw;
}

.price-tag-item-list {
  margin: 20px 30px;
  list-style-position: inside;
  min-height: 275px;
}

ul.price-tag-item-list li {
  font-size: 10px;
  margin-bottom: 20px;
}

.price-tag-item a {
  margin: 30px;
  color: rgb(203, 207, 209);
  text-decoration: underline;
  letter-spacing: 1px;
}

.price-tag-image-container {
  border-radius: 0 0 15px 15px;
}

.price-tag-item img {
  height: auto;
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}

.price-tag-item > img {
  vertical-align: bottom;
}

.price-tag-button {
  height: auto;
  display: block;
  width: calc(50% + 20px);
  font-size: 22px;
  margin-top: 10%;
  margin-left: auto !important;
  margin-right: auto !important;
  padding: 5px 25px;
  border-radius: 15px;
}

@media screen and (max-width: 639px) {
  #banner .uk-height-large {
    height: 200px;
    background-size: 110% !important;
  }

  #banner-title {
    font-size: 40px;
  }

  .price-tag-item-title {
    font-size: 20px;
  }

  .price-tag-item-description {
    font-size: 14px;
  }

  ul.price-tag-item-list li {
    font-size: 10px;
  }

  .price-tag-button {
    font-size: 12px;
  }
}

@media screen and (min-width: 1201px) {
  #banner .uk-height-large {
    min-height: 500px;
  }
}

#spye-series {
  .compare-type-section {
    background: @primary-color;
    color: white;
  }
  table {
    td {
      padding: 0px 0px 0px 20px !important;
      vertical-align: middle !important;
      align-items: center !important;
    }
  }
}
</style>